import { useDispatch, useSelector } from "react-redux"

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch()
export const useAppSelector =(selector)=> useSelector(selector)

// Custom hooks for common selectors
export const useAuth = () => useAppSelector((state) => state.auth)
export const useProjects = () => useAppSelector((state) => state.projects)
export const useSiteData = () => useAppSelector((state) => state.siteData)
export const useWorks = () => useAppSelector((state) => state.works)
export const useObservations = () => useAppSelector((state) => state.observations)
export const useFiles = () => useAppSelector((state) => state.files)
export const useDashboard = () => useAppSelector((state) => state.dashboard)
export const useUI = () => useAppSelector((state) => state.ui)
